import cn from 'classnames';
import { AdFormData, AdSize, AdsProvider } from './contracts';
import { CSSProperties } from 'react';

export type AdProps = AdFormData & {
  className?: string;
  style?: CSSProperties;
};

export const Ad = ({ provider, script, adSize, className, style }: AdProps) => {
  if (provider === AdsProvider.SnackMedia) {
    if (adSize === AdSize.video) {
      return <div id="snack_dex6" className={className} style={style} />;
    }

    return (
      <div
        id={adSize}
        className={cn(className, {
          'leaderboard-ad': adSize === AdSize.snack_ldb,
          'sticky-footer-ad': adSize === AdSize.snack_dex1,
        })}
        style={style}
      />
    );
  }

  if (!script) {
    return null;
  }

  return <div dangerouslySetInnerHTML={{ __html: script }} />;
};
